<template>
    <div class="bg_account">
        <mainMenu/>
        <div class="container">
            <div class="width100 d-flex justify-content-center align-items-center">
                <div class="col-lg-6 ">
                    <b-card class="my-5 mx-auto " header="Регистрация">
                        <b-form @submit="onSubmit" class="my-3">
                            <b-form-group class="mb-3" id="input-group-1" label="Фамилия:" label-for="input-1">
                                <b-form-input id="input-1" v-model="form.family" type="text" placeholder="Введите фамилию"
                                    required></b-form-input>
                            </b-form-group>
                            <b-form-group class="mb-3" id="input-group-2" label="Имя:" label-for="input-2">
                                <b-form-input id="input-2" v-model="form.name" type="text" placeholder="Введите имя"
                                    required></b-form-input>
                            </b-form-group>
                            <b-form-group class="mb-3" id="input-group-3" label="Отчество:" label-for="input-3">
                                <b-form-input id="input-3" v-model="form.lastname" type="text"
                                    placeholder="Введите отчество" required></b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" id="input-group-4" label="Пол" v-slot="{ ariaDescribedby }"
                                label-for="input-4">
                                <div class="d-flex justify-content-center">
                                    <b-form-radio class="mx-2 mt-3 radio-but" id="input-4" v-model="form.sex"
                                        :aria-describedby="ariaDescribedby" value="1">
                                        <span class="mx-2">Мужской</span></b-form-radio>
                                    <b-form-radio class="mx-2 mt-3 radio-but" id="input-5" v-model="form.sex"
                                        :aria-describedby="ariaDescribedby" value="0">
                                        <span class="mx-2">Женский</span></b-form-radio>
                                </div>
                            </b-form-group>

                            <b-form-group class="mb-4" id="input-group-6" label="Год рождения:" label-for="input-6">
                                <b-form-input id="input-6" v-model="form.birfdayYear" type="text"
                                    placeholder="Введите год рождения" required></b-form-input>
                            </b-form-group>
                            <b-form-group class="mb-3" id="input-group-7" label="Место работы:" label-for="input-7">
                                <b-form-input id="input-7" v-model="form.work" type="text"
                                    placeholder="Введите место работы" required></b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" id="input-group-8" label="Электронная почта:" label-for="input-8">
                                <b-form-input id="input-8" v-model="form.email" type="email" placeholder="Введите email"
                                    required></b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-2" id="input-group-9" label="Пароль:" label-for="input-9">
                                <b-form-input id="input-9" v-model="form.password" type="password"
                                    placeholder="Введите пароль" required></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-10" label="Повтор пароля:" label-for="input-10">
                                <b-form-input id="input-10" v-model="form.password_confirm" type="password"
                                    placeholder="Введите повторно пароль" required></b-form-input>
                            </b-form-group>

                            <b-button type="submit" size="lg" variant="primary" class="mx-2 my-4">Регистрация</b-button>
                            <b-button type="reset" size="lg" variant="outline-primary" class="mx-2 my-4">Очистить</b-button>
                        </b-form>
                    </b-card>
                </div>
            </div>
            <cabinetFooter />
        </div>
    </div>
</template>
<script>
import cabinetFooter from '@/components/cabinetFooter.vue'
import mainMenu from '@/components/mainMenu.vue'

export default {
    data() {
        return {
            form: {
                family: '',
                name: '',
                lastname: '',
                email: '',
                password: '',
                password_confirm: '',
                sex: '1',
                birfdayYear: '',
                work: ''
            }
        }
    },
    mounted() {
        if (this.$route.path == '/account/registration') {
            document.title = 'Регистрация';
        }
    },
    components: {
        cabinetFooter,
        mainMenu
    },
    methods: {
        onSubmit(event) {

            event.preventDefault()
            // alert(JSON.stringify(this.form)) 
            this.formValidate();
        },
        onReset(event) {
            event.preventDefault()
            this.form.email = ''
            this.form.password = ''
            this.form.family = ''
            this.form.name = ''
            this.form.lastname = ''
            this.form.password_confirm = ''
            this.form.sex = ''
            this.form.birfdayYear = ''
            this.form.work = ''
        },
        formValidate() {
            if (this.form.family.length < 3 || !this.form.family.match(/^[А-ЯЁ][а-яё]+[ -]*[А-ЯЁ]*[а-яё]*$/gm)) {
                this.showMessage(2, 'Ошибка', 'Фамилия должна содержать от 3 до 500 русских символов и начинаться с заглавной буквы');
            } else if (this.form.name.length < 3 || !this.form.name.match(/^[А-ЯЁ][а-яё]+$/gm)) {
                this.showMessage(2, 'Ошибка', 'Имя должно содержать от 3 до 500 русских символов и начинаться с заглавной буквы');
            } else if (this.form.lastname.length < 3 || !this.form.lastname.match(/^[А-ЯЁ][а-яё]+$/gm)) {
                this.showMessage(2, 'Ошибка', 'Отчество должно содержать от 3 до 500 русских символов и начинаться с заглавной буквы');
            } else if (!Number.isInteger(parseInt(this.form.birfdayYear)) || parseInt(this.form.birfdayYear) < 1900 || parseInt(this.form.birfdayYear) > parseInt(new Date().getFullYear())) {
                this.showMessage(2, 'Ошибка', 'Год рождения - четыре цифры');
            } else if (this.form.work.length < 3 || !this.form.work.match(/^[А-ЯЁа-яё0-9«»"]+((\s)?([А-ЯЁа-яё0-9«»"])+)*$/gm)) {
                this.showMessage(2, 'Ошибка', 'Место работы должно содержать от 3 до 500 русских символов, а также поддерживаются: цифры, кавычки и пробелы');
            } else if (this.form.email.length < 7 || !this.form.email.match(/^[a-z0-9_.-]+@[a-z0-9_.-]+.[a-z]+$/gm)) {
                this.showMessage(2, 'Ошибка', 'Электронная почта указана неверно');
            } else if (this.form.password.length < 6 || this.form.password.length > 500) {
                this.showMessage(2, 'Ошибка', 'Пароль должен содержать от 6 до 500 символов');
            } else if (this.form.password !== this.form.password_confirm) {
                this.showMessage(2, 'Ошибка', 'Пароли не идентичны');
            } else {
                this.sendForm();
            }
        },
        showMessage(popUp, title, text) {
            this.$store.commit('popUpWiev', popUp);
            this.$store.commit('popUpTitleWiev', title);
            this.$store.commit('popUpTextWiev', text);
        },
        sendForm() {
            this.axios.post(this.$store.getters.URL + '/account/registration',
                {
                    email: this.form.email,
                    password: this.form.password,
                    family: this.form.family,
                    name: this.form.name,
                    lastname: this.form.lastname,
                    password_confirm: this.form.password_confirm,
                    sex: this.form.sex,
                    year: this.form.birfdayYear,
                    work: this.form.work,
                    // email: this.form.email,
                    // password: this.form.password
                })
                .then(response => (
                    this.$store.commit('popUpWiev', response.data.popUp),
                    this.$store.commit('popUpTitleWiev', response.data.title),
                    this.$store.commit('popUpTextWiev', response.data.text),
                    this.$store.commit('reDirect', response.data.redirect)
                ))
                // .catch(function (error) {
                //     // console.log(error);
                // })
                ;
        }
    }
}
</script>
<style>
/* .radio-but .custom-control-input {
    box-shadow: 0px 0px 0px 0px #48015a;
} */
</style>